import {
    GET_BIN_LIST_PROGRESS, GET_BIN_LIST_SUCCESS, GET_BIN_LIST_FAILURE,
    ADD_BIN_PROGRESS, ADD_BIN_SUCCESS, ADD_BIN_FAILURE,
    EDIT_DELETE_BIN_PROGRESS, EDIT_DELETE_BIN_SUCCESS, EDIT_DELETE_BIN_FAILURE,

    RESET_MESSAGE,

} from '../types/actionTypes';

const initialState = {
    bin: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const bin_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_BIN_LIST_SUCCESS:
            return { ...state, bin: action.bin, loading: false };
        case GET_BIN_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_BIN_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
        case ADD_BIN_PROGRESS:
            return { ...state, loading: true };
        case ADD_BIN_SUCCESS:
            return { ...state, bin: [...state.bin, action.payload], loading: false, error: false, message:action.payload.message };
        case ADD_BIN_FAILURE:
            return { ...state, loading: false, error: action.payload, message:action.payload.message };
        case EDIT_DELETE_BIN_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_BIN_SUCCESS:
            return {
                ...state,
                bin: state.bin.map((bin) =>
                    bin.id === action.payload.id ? action.payload : bin
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_BIN_FAILURE:
            return { ...state, loading: false, error: action.payload, message:action.payload.message};

        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message

        default:
            return state
    }
}

export default bin_reducer;